<script setup>
import PositionLabel from '../elements/PositionLabel.vue'
import CoverImage from './CoverImage.vue'
import LikeButton from './LikeButton.vue'

defineProps({
  track: {
    type: Object,
    required: true,
  },
  label: {
    type: String,
    default: null,
  },
  large: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <div v-if="track" class="flex items-center pr-8">
    <div :class="large ? 'w-28' : 'w-24 ml-7'">
      <CoverImage :track="track" />
    </div>
    <div class="flex-1 pl-6">
      <div v-if="label">{{ label }}</div>
      <PositionLabel :track="track" />
      <div class="font-semibold line-clamp-1 willy:font-secondary" :class="large ? 'text-3xl' : 'text-2xl'">
        {{ track.title }}
      </div>
      <div class="line-clamp-1" :class="large ? 'text-xl' : 'text-lg'">
        {{ track.artist?.name }}
      </div>
    </div>
    <LikeButton :track="track" />
  </div>
</template>
